
import type { MontonioPaymentMethod } from './types';

/**
 * Array of valid Montonio payment methods
 */
export const MONTONIO_PAYMENT_METHODS = [
  "paymentInitiation",
  "blik",
  "cardPayments",
] as const;

/**
 * Type guard to validate if a value is a valid Montonio payment method
 * @param method - The method to validate
 * @returns True if the method is valid
 */
export function isValidMontonioPaymentMethod(method: any): method is MontonioPaymentMethod {
  return MONTONIO_PAYMENT_METHODS.includes(method);
}

/**
 * Type guard to validate if a bank ID is valid
 * @param bankId - The bank ID to validate
 * @returns True if the bank ID is valid
 */
export function isValidBankId(bankId: any): bankId is string {
  return typeof bankId === 'string' && bankId.trim().length > 0;
}
